export const info = {
  type: '图书馆类型',
  lib_id: '图书馆名称',
  school: '机构名称',
  name: '管理员姓名',
  mobile: '管理员手机号',
  code: '验证码',
  department: '所属部门',
  position: '职务',
  telephone: '座机号码'
}
